var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 此份問卷尚未開放填答，請於"+_vm._s(_vm.VaildInterval)+"進行填答，謝謝。 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }